import React from 'react';
import styles from './ContentRequired.module.css';

const ContentRequired = () => {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.contentWrapper}>
        <h1 className={styles.title}></h1>
        <p style={{ maxWidth: '100%' }} className={styles.description}>
          نحن حاليًا في صيانة وسنعود قريبًا. شكرًا لتفهمكم وصبركم!
        </p>
      </div>
    </div>
  );
};

export default ContentRequired;
